import { resources } from "@constants/hardcoded-strings";
import { ContentPageBody } from "@containers/common/content-page-body/content-page-body";
import { ContentPageHeader } from "@containers/common/content-page-header/content-page-header";
import { PolicyComponentAssociatedPolicy } from "@idw-types/policy-component-associated-policy";
import { AssociatedPoliciesTableContainer } from "./policy-component-associated-policies-table-container/associated-policies-table-container";
import { TableState } from "@tanstack/react-table";

type PolicyComponentAssociatedPoliciesTabProps = {
    associatedPolicies: Array<PolicyComponentAssociatedPolicy>;
    associatedPoliciesTableState: TableState;
}

export const PolicyComponentAssociatedPoliciesTab = ({ associatedPolicies, associatedPoliciesTableState }: PolicyComponentAssociatedPoliciesTabProps) => {
    return <div>
        <ContentPageHeader title={resources.pages.policyComponentDetails.tabs.associatedPolicies.title} />
        <ContentPageBody isMaxWidth={true}>
            <AssociatedPoliciesTableContainer
                associatedPolicies={associatedPolicies}
                tableState={associatedPoliciesTableState} />
        </ContentPageBody>
    </div>;
}